import React, { useRef } from "react"
import useDidMountEffect from "../../hooks/useDidMountEffect"
import VariableSelector from "../../variable-selector/VariableSelector"
import useCursorRect from "../../variable-selector/useCursorRect"
import TextInput from "./TextInput"

const TextInputContainer = ({
  onKeyDownProp,
  onKeyUpProp,
  onChangeProp,
  onBlurProp,
  onClickProp,
  onKeyDown,
  onKeyUp,
  onChange,
  onBlur,
  handleSelection,
  setSelectorRect,
  value,
  nextSelectionStart,
  showingVariableSelector,
  ...rest
}) => {
  const textInputRef = useRef(null)
  const rect = useCursorRect(textInputRef.current)

  // ensure variable selector has latest rect value when showing selector UI
  React.useEffect(() => {
    setSelectorRect(rect)
  }, [showingVariableSelector, rect])

  useDidMountEffect(() => {
    textInputRef.current.focus()
    textInputRef.current.setSelectionRange(
      nextSelectionStart,
      nextSelectionStart
    )
  }, [nextSelectionStart])

  return (
    <TextInput
      {...rest}
      onKeyDown={(value, e) => {
        onKeyDownProp && onKeyDownProp(e)
        onKeyDown(e)
      }}
      onKeyUp={(value, e) => {
        onKeyUpProp && onKeyUpProp(e)
        onKeyUp(e)
      }}
      onChange={(value, e) => {
        onChangeProp && onChangeProp(e)
        onChange(e)
      }}
      onBlur={(e) => {
        onBlurProp && onBlurProp(e)
        onBlur(e)
      }}
      onClick={(e) => {
        onClickProp && onClickProp(e)
        handleSelection(e)
      }}
      value={value}
      innerRef={textInputRef}
    />
  )
}

const TextInputVariableSelector = ({
  variables,
  value: valueProp,
  onKeyDown: onKeyDownProp,
  onKeyUp: onKeyUpProp,
  onChange: onChangeProp,
  onBlur: onBlurProp,
  onClick: onClickProp,
  ...rest
}) => (
  <VariableSelector variables={variables} value={valueProp}>
    {({
      onKeyDown,
      onKeyUp,
      onChange,
      onBlur,
      handleSelection,
      setSelectorRect,
      value: controlledValue,
      nextSelectionStart,
      showingVariableSelector
    }) => (
      <TextInputContainer
        {...rest}
        onKeyDownProp={onKeyDownProp}
        onKeyUpProp={onKeyUpProp}
        onChangeProp={onChangeProp}
        onBlurProp={onBlurProp}
        onClickProp={onClickProp}
        onKeyDown={onKeyDown}
        onKeyUp={onKeyUp}
        onChange={onChange}
        onBlur={onBlur}
        handleSelection={handleSelection}
        setSelectorRect={setSelectorRect}
        value={controlledValue}
        nextSelectionStart={nextSelectionStart}
        showingVariableSelector={showingVariableSelector}
      />
    )}
  </VariableSelector>
)

TextInputVariableSelector.displayName = "TextInputVariableSelector"

export default TextInputVariableSelector
